// @ts-strict-ignore
import React from "react";
import NextLink from "components/parts/NextLink";
import styled from "@emotion/styled";
import { Button } from "@hubble/web";

import TextLink from "../NextLink/TextLink";
import { color } from "@hubble/tokens/web";
import { mediaQuery, Text, Flex, HubbleProvider } from "@hubble/web";

import HubspotModal from "components/common/hubspotModal";

import { IconArrowRight } from "@hubble/icons";

export const StyledLink = styled(NextLink)`
  @media ${mediaQuery.mobileXsDown} {
    width: 100%;
  }
`;

export const StyledButton = styled(Button.Tertiary)`
  background: ${color.base.brandCyan};
  &:hover,
  &:focus {
    background: ${color.base.brandCyan};
  }
  @media ${mediaQuery.mobileXsDown} {
    width: 100%;
  }
`;

export function ContentfulButton(props) {
  const [modalOpen, setModalOpen] = React.useState(false);
  const { hubspotFormId, hubspotTitle, hubspotSubtitle } = props;

  const handleOpenHubspot = () => {
    setModalOpen(true);
  };

  const getButton = (props) => {
    const { variant, text, link, trackingId, size, ...rest } = props;
    switch (variant) {
      case "ButtonPrimary":
        return hubspotFormId ? (
          <Button.Primary
            cta={text}
            size={size}
            {...rest}
            onClick={handleOpenHubspot}
          />
        ) : (
          <NextLink href={link} id={trackingId}>
            <Button.Primary cta={text} size={size} {...rest} />
          </NextLink>
        );
      case "ButtonSecondary":
        return hubspotFormId ? (
          <Button.Secondary
            cta={text}
            size={size}
            {...rest}
            onClick={handleOpenHubspot}
          />
        ) : (
          <NextLink href={link} id={trackingId}>
            <Button.Secondary cta={text} size={size} {...rest} />
          </NextLink>
        );
      case "ButtonTertiary":
        return hubspotFormId ? (
          <Button.Tertiary
            cta={text}
            size={size}
            {...rest}
            onClick={handleOpenHubspot}
          />
        ) : (
          <NextLink href={link} id={trackingId}>
            <Button.Tertiary cta={text} size={size} {...rest} />
          </NextLink>
        );
      case "ButtonBlue":
        return hubspotFormId ? (
          <StyledButton
            cta={text}
            size={size}
            {...rest}
            onClick={handleOpenHubspot}
          />
        ) : (
          <StyledLink as="button" href={link} id={trackingId}>
            <StyledButton cta={text} size={size} {...rest} />
          </StyledLink>
        );
      case "TextLink":
        return hubspotFormId ? (
          <Text.Link
            size={"sm"}
            color="#00A3FF"
            bold
            marketing
            {...rest}
            onClick={handleOpenHubspot}
          >
            {text}
          </Text.Link>
        ) : (
          <TextLink href={link} id={trackingId}>
            <Text.Body size={"sm"} color="#00A3FF" bold marketing {...rest}>
              {text}
            </Text.Body>
          </TextLink>
        );
      case "CardIconButton":
        return (
          <Flex justifyContent={"space-between"} alignItems="center">
            <Text.Heading size={"sm"} marketing>
              {text}
            </Text.Heading>
            <NextLink id={trackingId} href={link}>
              <Button.Secondary
                aria-label="my intent here"
                data-testid="btn-test"
                icon={<IconArrowRight />}
                size="lg"
              />
            </NextLink>
          </Flex>
        );
      default:
        break;
    }
  };
  return (
    <React.Fragment>
      {getButton({ ...props })}
      {hubspotFormId && (
        <HubbleProvider scheme={"light"}>
          <HubspotModal
            formId={hubspotFormId}
            modalOpen={modalOpen}
            modalTitle={hubspotTitle}
            modalSubtitle={hubspotSubtitle}
            closeModal={() => {
              setModalOpen(false);
            }}
          />
        </HubbleProvider>
      )}
    </React.Fragment>
  );
}
